/*
 *  Service Worker
 */

if ('serviceWorker' in navigator) {

    navigator.serviceWorker.register('/service-worker.js')
        .then(function(reg) { console.log('SW registered: ' + reg.scope); })
        .catch(function(error) { console.log('SW registration failed: ' + error); });

}

$(function(){

    var modal = '#modal-full',
        $modal = $(modal);

    $('.video')
        .on('play', function(){

            var $this = $(this);
            var src = $this.data('src');
            var title = $this.find('.title').text();
            $modal.find('.title').text( title );
            $modal.find('.description').html( $this.find('.description').html() );

            $modal.find('.vreel, .vportfolio').css({display: 'none'});
            var show = title ? '.vportfolio' : '.vreel';

            //mostamos y ponemos el vídeo solo en esa
            $modal.find(show).css({display: 'flex'});

            var $wrapper = $modal.find(show).find('.mv-video');
            $wrapper.empty().append('<iframe src="'+src+'" />');
            UIkit.modal(modal).show();

        })
        .on('click', function(e){

            $this = $(this);
            e.preventDefault();

            var slug = $this.attr('id'),
                title = $this.find('.title').text(),
                rel = $this.find('a').attr('rel'),
                url = $this.find('a').attr('href');

            if(rel !== 'nofollow'){
                //console.log('pushState', slug);
                history.pushState({id: slug}, title, url);
            }

            $this.trigger('play');

        })
    ;

    $modal
        .on('beforehide', function(){
            //console.log('modal.close');
            $modal.find('.title').text('');
            $modal.find('iframe').attr('src', '');
            $modal.find('.description').html('');
        });

    $('#modal-full').find('.uk-close').on('click', function(){
        //console.log('pushState', '/');
        history.pushState({id: false}, false, '/');
    });

    window.onpopstate =  function(event) {
        //console.log('popstate', event.state);
        UIkit.modal(modal).hide();
        if(event.state && 'id' in event.state){
            $("#" + event.state.id).trigger('play');
        }
    };

});
